import loadable from "@loadable/component";

const StandWithUkraine = loadable(() => import("./StandWithUkraine.page"));

export default { component: StandWithUkraine };
